import { call, get, sync } from 'vuex-pathify';
import { transform } from 'ol/proj';
export default {
  computed: {
    isRealtimeStationsMeasurementsButtonActive: sync('edit/isRealtimeStationsMeasurementsButtonActive'),
    realtimeStationsMeasurementsStations: sync('edit/realtimeStationsMeasurementsStations'),
    isRealtimeStationsDirectionsButtonActive: sync('edit/isRealtimeStationsDirectionsButtonActive'),
    realtimeStationsDirectionsStations: sync('edit/realtimeStationsDirectionsStations'),

    realtimeStationsMeasurementsWsUrl: get('admin/settingsValues@realtime_stations_measurements_websocket_address'),
    realtimeStationsDirectionsWsUrl: get('admin/settingsValues@realtime_stations_directions_websocket_address'),

    isRealtimeStationsModuleEnabled: get('admin/additionalModules@REALTIME_STATIONS_MEASUREMENTS.enabled'),
    isRealtimeStationsSettingEnabled: get('admin/settingsValues@realtime_stations_measurements_module_enabled'),
    realtimeStationsPermissions: get('users/toolsPermissions@REALTIME_STATIONS_MEASUREMENTS.main_value'),
    realtimeStationsLayer: get('admin/modulesMapping@realtime_stations_measurements.layer_id'),
    realtimeStationsStationIdAttribute: get('admin/modulesMapping@realtime_stations_measurements.attribute_station_id'),
    realtimeStationsEnabled() {
      return (
        this.layerId == this.realtimeStationsLayer &&
        this.isRealtimeStationsModuleEnabled &&
        this.isRealtimeStationsSettingEnabled &&
        this.realtimeStationsPermissions > 0
      );
    },
    isRealtimeStationsDisabled() {
      return !this.isAnyFeatureSelected;
    },
    realtimeStationsMeasurementsButton() {
      return this.realtimeStationsEnabled && this.realtimeStationsMeasurementsWsUrl
        ? [
            {
              name: 'realtimeStationsMeasurements',
              disabled: this.isRealtimeStationsDisabled,
              ...(this.isRealtimeStationsDisabled && {
                tooltip: this.$i18n.t('sidebar.realtimeStations.selectAtLeastOneFeature'),
              }),
              translationPath: this.isRealtimeStationsMeasurementsButtonActive
                ? 'sidebar.realtimeStations.measurementsButtonOffTitle'
                : 'sidebar.realtimeStations.measurementsButtonOnTitle',
              small: true,
              elevation: '0',
              color: 'primary',
              loading: this.isRealtimeStationsMeasurementsButtonLoading,
            },
          ]
        : [];
    },
    realtimeStationsDirectionsButton() {
      return this.realtimeStationsEnabled && this.realtimeStationsDirectionsWsUrl
        ? [
            {
              name: 'realtimeStationsDirections',
              disabled: this.isRealtimeStationsDisabled,
              ...(this.isRealtimeStationsDisabled && {
                tooltip: this.$i18n.t('sidebar.realtimeStations.selectAtLeastOneFeature'),
              }),
              translationPath: this.isRealtimeStationsDirectionsButtonActive
                ? 'sidebar.realtimeStations.directionsButtonOffTitle'
                : 'sidebar.realtimeStations.directionsButtonOnTitle',
              small: true,
              elevation: '0',
              color: 'primary',
              loading: this.isRealtimeStationsDirectionsButtonLoading,
            },
          ]
        : [];
    },
  },
  data: () => ({
    isRealtimeStationsMeasurementsButtonLoading: false,
    isRealtimeStationsDirectionsButtonLoading: false,
  }),
  methods: {
    getLayerFeatures: call('layers/getLayerFeatures'),
    realtimeStationsMeasurementsAction() {
      if (this.isRealtimeStationsMeasurementsButtonActive) {
        this.toggleOffRealtimeStations('measurements');
      } else {
        this.toggleOnRealtimeStations('measurements');
      }
    },
    realtimeStationsDirectionsAction() {
      if (this.isRealtimeStationsDirectionsButtonActive) {
        this.toggleOffRealtimeStations('directions');
      } else {
        this.toggleOnRealtimeStations('directions');
      }
    },
    async toggleOnRealtimeStations(type) {
      const typeCapitalize = this.$_capitalize(type);
      this[`isRealtimeStations${typeCapitalize}ButtonLoading`] = true;
      const payload = {
        layer_id: this.layerId,
        params: {
          with_features: true,
          with_collection_bbox: false,
          with_count: false,
          with_geometry: type === 'directions',
        },
        features_filter: {
          $IN: {
            [this.isUseQualifiedNames
              ? this.idPropertyName
              : `${this.currentLayerDataSourceName}.${this.idPropertyName}`]: this.currentLayerSelectedFeatures,
          },
        },
      };
      try {
        const r = await this.getLayerFeatures(payload);
        this[`realtimeStations${typeCapitalize}Stations`] = this.$_arrayToObject(
          (r.data.data?.features?.features || [])
            .filter(feature => !!feature.properties?.[this.realtimeStationsStationIdAttribute])
            .map(feature => {
              return {
                stationId: feature.properties?.[this.realtimeStationsStationIdAttribute] || '',
                ...(feature.geometry
                  ? { coordinates: transform(feature.geometry.coordinates, this.$_config.defaultEpsg, 'EPSG:4326') }
                  : {}),
              };
            }),
          'stationId'
        );
        this[`isRealtimeStations${typeCapitalize}ButtonActive`] = true;
        this.$root.$emit('socket.connect', { name: `realtimeStations${typeCapitalize}` });
      } finally {
        this[`isRealtimeStations${typeCapitalize}ButtonLoading`] = false;
      }
    },
    toggleOffRealtimeStations(type) {
      const typeCapitalize = this.$_capitalize(type);
      this.$root.$emit(`clearRealtimeStations${typeCapitalize}Stations`);
      this[`realtimeStations${typeCapitalize}Stations`] = {};
      this[`isRealtimeStations${typeCapitalize}ButtonActive`] = false;
      this.$root.$emit('socket.close', { name: `realtimeStations${typeCapitalize}` });
    },
  },
  watch: {
    realtimeStationsEnabled(nV, oV) {
      if (!nV && oV) {
        if (this.isRealtimeStationsMeasurementsButtonActive) this.toggleOffRealtimeStations('measurements');
        if (this.isRealtimeStationsDirectionsButtonActive) this.toggleOffRealtimeStations('directions');
      }
    },
  },
  beforeDestroy() {
    this.toggleOffRealtimeStations('measurements');
    this.toggleOffRealtimeStations('directions');
  },
};
